export default "__VITE_PUBLIC_ASSET__16d96beb__"